import { ODSSupportMessageMode } from "./ODSSupportMessage.types";

export { getSupportMessageIconName };

function getSupportMessageIconName(mode: ODSSupportMessageMode) {
  if (mode === "error") return "error-type-bold";
  if (mode === "success") return "success-type-bold";
  return "information-type-bold";
}
